module.exports = __webpack_public_path__ + "static/img/icon_line.656906e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/channelServices/icon_line.png
// module id = b0FM
// module chunks = 0